// extracted by mini-css-extract-plugin
export default {"forbiddenPage":"Forbidden_forbidden-page__QkOKZ","title":"Forbidden_title__8Nmir","description":"Forbidden_description__i3sc9","btnBack":"Forbidden_btn-back__7k0qo"};